<template>
  <div>
    <section class="mx-6 max-w-screen-md md:mx-8 lg:mx-auto">
      <h3 class="!mb-0 !text-2xl">Written by</h3>
      <div class="mb-8 w-full border-b border-grey-300 pb-4 md:pb-8"></div>
      <div class="flex flex-col gap-8">
        <div v-for="(author, idx) in authorData" :key="idx" class="flex gap-8">
          <img
            :src="`${author.content.profileImg?.filename}/m/224x224/smart/`"
            :alt="author.content.profileImg?.alt"
            class="mb-8 h-10 w-10 rounded-full"
          />
          <div class="mb-8">
            <p class="!mb-1 font-bold">
              {{ author.content.name }}
            </p>
            <p class="!mb-4">{{ author.content.jobTitle }}</p>
            <p v-if="author.content.bio" class="!mb-4">
              {{ `${author.content.bio.substring(0, 240)}...` }}
            </p>
            <BtnText
              arrow="right"
              :link="true"
              :external="false"
              :url="`/${author.full_slug}/`"
              :small="true"
              class="!justify-start !fill-green-800 !text-green-800"
              >See all articles</BtnText
            >
          </div>
        </div>
      </div>
      <div class="mb-8 w-full border-b border-grey-300"></div>
      <p class="!mb-4 text-center font-medium md:text-left">
        Share this post with your mates!
      </p>
      <SocialButtons :data="socialData" hoz-align="center md:justify-start" />
    </section>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  authorData: {
    content: {
      name: string;
      bio: string;
      jobTitle: string;
      profileImg?: {
        filename: string;
        alt: string;
      };
    };
    full_slug: string;
  }[];
}>();

const socialData = {
  facebook: {
    share: true,
  },
  threads: {
    share: true,
  },
  twitter: {
    share: true,
  },
  linkedin: {
    share: true,
  },
  email: {
    share: true,
  },
};
</script>
